import * as React from 'react';
import * as ReactMarkdown from 'react-markdown';
import { MarkdownPropsType } from './types';

const Markdown : React.StatelessComponent<MarkdownPropsType> = ( props : MarkdownPropsType ) => {
  if ( !props.source ) {
    return null;
  }

  return <ReactMarkdown className={ props.className } source={ props.source } />;
};

export default Markdown;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Markdown/Markdown.tsx